import React, { Component } from 'react';
import NavLink from './NavLink'
import './Header.css';

class Header extends Component {
    render() {

        return (
            <header>
                <div className="logo">
                    <NavLink to="/"><img src="/img/logo.jpg" width="200" title="George Otto Art" alt="George Otto Art"/></NavLink>
                </div>

                <div id="menu_icon"></div>
                <nav>
                    <ul>
                        <li><NavLink to="/" onlyActiveOnIndex={true}>Home</NavLink></li>
                        <li><NavLink to="/about">About</NavLink></li>
                        <li><NavLink to="/contact">Contact</NavLink></li>
                    </ul>
                </nav>

                <div className="footer clearfix">
                    <div className="rights">
                        <p>Copyright © { new Date().getFullYear() } George Otto</p>
                    </div>
                </div>
            </header>
        )
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js